import { render, staticRenderFns } from "./FormCanvas.vue?vue&type=template&id=bbd2e054&scoped=true&"
import script from "./FormCanvas.vue?vue&type=script&lang=ts&"
export * from "./FormCanvas.vue?vue&type=script&lang=ts&"
import style0 from "./FormCanvas.vue?vue&type=style&index=0&id=bbd2e054&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd2e054",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VCardTitle,VIcon})
